import { createListenerMiddleware, } from '@reduxjs/toolkit'
import { Middleware } from 'redux'
import { languageChanged } from '../../App/app';
import i18n from '../../i18n/i18n';
import { RootState } from '../store';

const listenerMiddlewarei18n = createListenerMiddleware();

listenerMiddlewarei18n.startListening( {
  actionCreator: languageChanged,
  effect: async( action, listenerApi ) => {

    const store = listenerApi.getState() as RootState;

    i18n.changeLanguage( action.payload );
    document.documentElement.setAttribute( 'lang', store.app.language );

  }
} )

export default listenerMiddlewarei18n;
